import React from 'react';
import Radio, { RadioProps } from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { alpha, styled } from '@mui/material/styles';

import { ThemeColor } from '../theme';
import { colors } from '../theme/tokens.colors';
import { uikitPalette } from '../theme/uikitPalette';

export interface UIKitRadioButtonProps extends Omit<RadioProps, 'color'> {
  label?: React.ReactNode;
  color?: ThemeColor;
}

const StyledRadio = styled(Radio, {
  shouldForwardProp: (prop) => prop !== 'mainColor',
})<{ mainColor: string }>(({ mainColor }) => ({
  // estado base
  color: mainColor,

  '&:hover': {
    backgroundColor: alpha(mainColor, 0.12),
  },

  '&.Mui-focusVisible': {
    backgroundColor: alpha(mainColor, 0.12),
  },

  // seleccionado (usamos la clase de estado de MUI)
  '&.Mui-checked': {
    color: mainColor,
  },
  '&.Mui-checked:hover': {
    backgroundColor: alpha(mainColor, 0.12),
  },

  // disabled
  '&.Mui-disabled': {
    color: colors.neutral[200],
  },
}));

const UIKitRadioButton: React.FC<UIKitRadioButtonProps> = ({
  label,
  color = 'primary',
  ...radioProps
}) => {
  const mainColor = uikitPalette[color].main;

  const radio = (
    <StyledRadio
      color="default" // usamos siempre default, el color real lo da nuestra clase
      disableRipple
      onBlur={radioProps.onBlur}
      mainColor={mainColor}
      {...radioProps}
    />
  );

  if (!label) {
    return radio;
  }

  return <FormControlLabel control={radio} label={label} />;
};

export default UIKitRadioButton;
